import { useQuery } from '@tanstack/react-query'
import moment from 'moment'

import type { FeedConsumptionGroupItem } from '../types'
import { aggregateAllGroupsToFetchData } from './aggregateFeedConsumptionAllGroups'
import GroupsApiService from 'services/groupsApiService'

export interface UseFeedConsumptionChartAllParams {
	startDate: number
	endDate: number
	enabled?: boolean
}

export function useFeedConsumptionChartAll({
	startDate,
	endDate,
	enabled = true,
}: UseFeedConsumptionChartAllParams) {
	const queryKey = [
		'feed-consumption-chart-all',
		moment(startDate).format('YYYY-MM-DD'),
		moment(endDate).format('YYYY-MM-DD'),
	] as const

	const { data, isLoading, isError, error } = useQuery({
		queryKey,
		enabled,
		queryFn: async () => {
			const response = await GroupsApiService.getDataForConsuptionChartAll(
				startDate,
				endDate,
			)
			const groups: FeedConsumptionGroupItem[] = Array.isArray(response?.data)
				? response.data
				: []
			return aggregateAllGroupsToFetchData(groups, startDate, endDate)
		},
		staleTime: 60 * 1000,
		refetchOnMount: false,
	})

	return {
		fetchData: data?.fetchData ?? [],
		distributedFood: data?.distributedFood ?? 0,
		consumptionFood: data?.consumptionFood ?? 0,
		isLoading,
		isError,
		error,
	}
}
